function getFileType(fileName) {
  if (!fileName || typeof fileName !== 'string') {
    return 'unknown'; // Handle invalid inputs
  }

  // Define common file types and their extensions
  const fileTypes = {
    image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff'],
    document: [
      'pdf',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pptx',
      'txt',
      'rtf',
      'odt',
    ],
    video: ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm'],
    audio: ['mp3', 'wav', 'ogg', 'm4a', 'flac', 'aac'],
    archive: ['zip', 'rar', '7z', 'tar', 'gz'],
    code: ['js', 'html', 'css', 'java', 'py', 'c', 'cpp', 'cs', 'ts', 'json'],
  };

  // Extract the file extension
  const fileExtension = fileName.split('.').pop().toLowerCase();

  // Ensure there is an extension
  if (!fileExtension || fileExtension === fileName) {
    return 'unknown';
  }

  // Check the file type
  for (const [type, extensions] of Object.entries(fileTypes)) {
    if (extensions.includes(fileExtension)) {
      return type;
    }
  }

  // Return 'unknown' if no match is found
  return '-';
}

export default getFileType;
